import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../../../components/layout/PageTemplate';
import { ResultsListPageViewProps, RaceCardItem } from './resultslistpage.props';

function RaceCard({ race, lang }: { race: RaceCardItem; lang: string }) {
  return (
    <Link
      to={`/results/${race.id}?lang=${lang}`}
      className="block bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border border-gray-100"
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-2">{race.name}</h2>
      {race.startDate && (
        <p className="text-sm text-gray-500">
          {new Date(race.startDate).toLocaleDateString(lang === 'mk' ? 'mk-MK' : lang === 'al' ? 'sq-AL' : 'en-US', {
            year: 'numeric', month: 'long', day: 'numeric',
          })}
        </p>
      )}
      {race.raceTypes && race.raceTypes.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-3">
          {race.raceTypes.map((rt) => (
            <span key={rt.id} className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">
              {rt.name}
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}

const ResultsListPageView: React.FC<ResultsListPageViewProps> = ({
  lang, setLang, t, rr, loading, racesExist, seriesGroups, standaloneRaces,
}) => {
  return (
    <PageTemplate lang={lang} setLang={setLang} t={t} forceScrolled={true}>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white" style={{ paddingTop: 80 }}>
          <div className="max-w-7xl mx-auto px-4 py-6 sm:py-8">
            <h1 className="text-2xl sm:text-3xl font-bold">{t.results}</h1>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 py-8">
          {loading ? (
            <div className="flex justify-center py-16">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
            </div>
          ) : !racesExist ? (
            <p className="text-center text-gray-500 py-16">{rr.noResults || 'No results available'}</p>
          ) : (
            <div className="space-y-8">
              {seriesGroups.map((group) => (
                <div key={group.name}>
                  <h2 className="text-xl font-bold text-gray-800 mb-4">{group.name}</h2>
                  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {group.races.map((race) => (
                      <RaceCard key={race.id} race={race} lang={lang} />
                    ))}
                  </div>
                </div>
              ))}

              {standaloneRaces.length > 0 && (
                <div>
                  {seriesGroups.length > 0 && (
                    <h2 className="text-xl font-bold text-gray-800 mb-4">
                      {rr.otherRaces || 'Other Races'}
                    </h2>
                  )}
                  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {standaloneRaces.map((race) => (
                      <RaceCard key={race.id} race={race} lang={lang} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </PageTemplate>
  );
};

export default ResultsListPageView;
